<template>
<div class="image-preview">
  <div
    class="image-preview__image"
    :style="`background-image: url(${selectedImage});`"
    />

  <div class="image-preview__navigation">
    <div
      class="image-preview__navigation__item animation"
      v-for="(src, index) in images"
      :key="index"
      :style="`background-image: url(${src});`"
      @click="imageIndex = index"
      />
  </div>
</div>
</template>
<script>
export default {
  data () {
    return {
      imageIndex: 0,
      images: [
        require('@/assets/HeadQ_preview.png'),
        require('@/assets/HeadQ_Package.png')
      ]
    }
  },
  computed: {
    selectedImage () {
      return this.images[this.imageIndex]
    }
  }
}
</script>
<style lang="less" scoped>
  @import '~style/variables.less';

  .image-preview {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    height: auto;

    &__image {
      height: 200px;
      width: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }

    &__navigation {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-top: 15px;

      &__item {
        height: 40px;
        width: 40px;
        border-radius: 3px;
        overflow: hidden;
        box-shadow: @shadow;
        margin-right: 10px;
        margin-bottom: 10px;
        box-sizing: border-box;
        filter: grayscale(1);
        cursor: pointer;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;

        &:hover {
          transform: scale(1.05);
          filter: grayscale(0);
        }

        &:active {
          transform: scale(1);
          box-shadow: none;
        }
      }
    }
  }
</style>
